import React from 'react'

import eventDateRangeFormatter, {
  EventForTimeFormatter,
  formatTimezone
} from './eventDateRangeFormatter'

import { isIE } from 'shared/helpers'
import { Trans } from '@lingui/react'

const EventDateRangeFromApi = React.lazy(
  () => import('front-end/src/pages/manage-events/EventDateRangeFromApi')
)

export interface IEventFormattedTimeProps {
  event: EventForTimeFormatter
  timezone?: string | null
}

const EventFormattedTime = (props: IEventFormattedTimeProps) => {
  let date: JSX.Element | null | undefined | string
  const { event, timezone } = props

  if (isIE) {
    date = <EventDateRangeFromApi {...props} />
  } else {
    date = eventDateRangeFormatter(event, timezone ?? undefined)
    if (!date)
      return (
        <span>
          <Trans id="Not Set" />
        </span>
      )
  }

  return (
    <>
      <span className="event-date range">{date} </span>
      {timezone && (
        <span className="event-date timezone">{formatTimezone(timezone)}</span>
      )}
    </>
  )
}

export default EventFormattedTime
